import { BaseStore } from './base.store';
import { IStore } from './store.interface';
import { UserData } from '../../dtos/user-data.dto';
import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import userService from '../../services/user.service';
import { RootStore } from './index';

export class UserStore extends BaseStore implements IStore<UserData> {
    public data: UserData;

    private readonly ALLOW_LTE_PERM = 'view_lte';
    private readonly ALLOW_5GSA_PERM = 'view_5gsa';

    constructor(rootStore: RootStore) {
        super(rootStore);
        makeObservable(this, {
            data: observable,
            load: action,
            isAuthenticated: computed,
            isEditorRole: computed,
            singleCustomerName: computed
        });
    }

    public async load() {
        try {
            this.setIsLoading(true);
            const res = await userService.getUser();
            runInAction(() => {
                this.data = res;
                this.setIsLoading(false);
            });
        } catch (e) {
            runInAction(() => {
                this.data = null;
                this.setIsLoading(false);
            });
        }
    }

    get isAuthenticated() {
        return !!this.data;
    }

    get isEditorRole() {
        return this.data?.permissions?.some(perm => perm.name === 'settings_edit');
    }

    get isMultiCustomerRole() {
        return this.data?.permissions?.some(perm => perm.name === 'multi_customer');
    }

    get isUnauthorizedDestinationsEditable() {
        return this.data?.permissions?.some(perm => perm.name === 'unauthorized_destinations_settings_edit');
    }

    get singleCustomerName() {
        return this.data.customerName;
    }

    get ratTypesPermissions(): string[] {
        return this.data?.permissions?.filter(perm => perm.name === this.ALLOW_LTE_PERM || perm.name === this.ALLOW_5GSA_PERM)
            .map(perm => perm.name === this.ALLOW_LTE_PERM ? 'LTE' : '5GSA');
    }

    get isAdminRole() {
        return this.data?.permissions?.some(perm => perm.name === 'oem_configure');
    }
}
